import { render, staticRenderFns } from "./SubHeader2.vue?vue&type=template&id=cb247160&scoped=true&"
import script from "./SubHeader2.vue?vue&type=script&lang=js&"
export * from "./SubHeader2.vue?vue&type=script&lang=js&"
import style0 from "./SubHeader2.vue?vue&type=style&index=0&id=cb247160&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb247160",
  null
  
)

export default component.exports